interface DefaultModalProps {
  open: boolean;
  onClose: () => void;
  className?: string;
  children: React.ReactNode;
}

export default function DefaultModal({
  open,
  onClose,
  children,
  className,
}: DefaultModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div
        className={`
          bg-white rounded-xl w-full max-w-[40vw]
          max-h-[90vh] shadow-lg overflow-hidden
          ${className}
        `}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
